import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import centerServices from "../../services/center.services";
import xrayBookingsServices from "../../services/xrayBookings.services";
import BookingList from "../../components/XrayBookings/XrayBookingsList";
import XrayBookingForm from "../../components/XrayBookings/XrayBookingForm";
import { formattedDate, formattedDateTime } from "../../helpers/Helper";
import ExportExcel from "../../components/ExportExcel";
import { BookingStatusText, BookingStatusWithID } from "../../constants/bookingStatus";
const XrayBooking = () => {
  const [modal, setModal] = React.useState(false);
  const toggle = () => setModal(!modal);
  const [centers, setCenters] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [isAddMode, setIsAddMode] = useState("Add");
  const [isCenter, setIsCenter] = useState(true);
  const [xrayBookings, setXrayBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllCenters = () => {
    centerServices
      .getAllCenter()
      .then((res) => {
        if (res.data.status === true) {
          setCenters(res.data.centers);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getAllBookings = async () => {
    const bookings = await xrayBookingsServices.bookingListApi();
    if (bookings.status === 200) {
      setXrayBookings(bookings.data.booking_details);
    }
    setLoading(false);
  };
  useEffect(() => {
    getAllCenters();
    getAllBookings();
  }, []);

  const handleSelect = (key) => {
    if (key === "center-info") {
      setIsCenter(true);
    } else setIsCenter(false);
  };
  // const rejectedBooking = xrayBookings.filter(item=> item.center_accepted_status===2);
  // const filterBooking =  xrayBookings.map(x => {x.booking_date=formattedDate(x.booking_date), x.appointment_date=formattedDate(x.appointment_date); return x});
  const filterBooking = xrayBookings.map((item, index) => {
    if (item.booking_date) {
      item.sr_no = index + 1
      // booking_date is now formatted in the table column formatter
      item.appointment_date = formattedDate(item.appointment_date);
    }
    return item
  });

  const getBookingStatusText = (status) => {
    return BookingStatusText[status] || 'Unknown';
  };

  const filterExcelData = xrayBookings.map((item, index) => {
    const obj = {
      "Sr.No.": index + 1,
      "Booking Id": item.xray_booking_id,
      "App User": item.user_id?.name || 'N/A',
      "Patient Name": item.patent_name,
      "Booking Date": formattedDateTime(item.booking_date),
      "X-ray Type": item.xray_type_name,
      "Investigation Report": item.inves_report_opted ? 'Yes' : 'No',
      "Fee Charged": item.booking_amount ? `₹${item.booking_amount}` : 'N/A',
      "Appointment Date": formattedDate(item.appointment_date),
      "Appointment Slot": item.appointment_slot,
      "Booking Status": getBookingStatusText(item.booking_status_id)
    }
    return obj
  })
  // console.log('filterBooking', filterBooking)
  // console.log('filterBooking', dddd)
  return (
    <React.Fragment>
      {/*page-wrapper*/}
      <div className="page-wrapper">
        {/*page-content-wrapper*/}
        <div className="page-content-wrapper">
          <div className="page-content">
            <>
              {/*breadcrumb*/}
              <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                <div className="ps-3">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0 p-0">
                      <li className="breadcrumb-item">
                        <a href="#">
                          {/* <i className="bx bx-home-alt" /> */}
                        </a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        X-ray Bookings
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="ms-auto">
                  <div className="btn-group">
                    {/* <button className="btn btn-primary"
                                            onClick={() =>{
                                                toggle();
                                                setIsAddMode('Add')
                                                }}><i className="bx bx plus" />Add</button> */}
                    <ExportExcel excelData={filterExcelData} fileName={"bookings"} />
                    <Modal isOpen={modal} toggle={toggle} size="lg">
                      <XrayBookingForm
                        toggle={toggle}
                        getAllBookings={getAllBookings}
                        isAddMode={isAddMode}
                        selectedRow={selectedRow}
                        centers={centers}
                      />
                    </Modal>
                  </div>
                </div>
              </div>
              {/*end breadcrumb*/}
              <div className="card">
                {/* 
                                <Tabs
                                    defaultActiveKey="center-info"
                                    id="fill-tab-example"
                                    className="mb-3 h6 tab-title-style border-0"
                                    fill
                                    onSelect={(e) => handleSelect(e)}
                                >
                                    <Tab eventKey="center-info" title="Accepted Bookings">
                                        <div className="bg-dark h-25"></div>
                                        <div className="card-body">

                                        </div>
                                    </Tab>
                                    <Tab eventKey="center-login" title="Rejected Bookings">
                                        <div className="card-body">
                                        <BookingList bookings={rejectedBooking} setIsAddMode={setIsAddMode} setSelectedRow={setSelectedRow} setModal={setModal}getAllCenters={getAllCenters}  />
                                        </div>
                                    </Tab>
                                </Tabs> */}
                <div className="card-body">
                  <BookingList
                    bookings={filterBooking}
                    loading={loading}
                    setIsAddMode={setIsAddMode}
                    setSelectedRow={setSelectedRow}
                    setModal={setModal}
                    getAllCenters={getAllCenters}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default XrayBooking;
